<script setup>
import { ref, inject } from 'vue';
import ProductCardTabContent from '@/app/components/product-card/product-card-tab-content.vue';
import { useProductsStore } from '@/app/stores/productsStore.js';
const productsStore = useProductsStore();

const config = inject('config');
const gaPush = inject('gaPush');
const props = defineProps(['tabs', 'quoteLink', 'productName', 'tags', 'gaPrefix', 'category']);

const activeTab = ref(0);
const allTabsArr = ref(null);
const allPanelsArr = ref(null);

function isSelected(tabNumber) {
  return tabNumber === activeTab.value;
}

function setTabindex(tabNumber) {
  return isSelected(tabNumber) ? '0' : '-1';
}

function handleTabBtnClick(tabNumber) {
  activeTab.value = tabNumber;
  handleClickGA();
}

function handleKeydown(i, param) {
  if (param === 'down') {
    [...allPanelsArr.value][activeTab.value].focus();
  } else {
    const length = props.tabs.length - 1;
    const nextTab = activeTab.value + param;

    if (nextTab <= length && nextTab >= 0) {
      activeTab.value = nextTab;
    } else if (nextTab > length) {
      activeTab.value = 0;
    } else if (nextTab < 0) {
      activeTab.value = length;
    }
    [...allTabsArr.value][activeTab.value].focus();
    handleClickGA();
  }
}

function handleClickGA() {
  const gaPayload = {
    event: props.gaPrefix + 'finance_example',
    link_text: props.tabs[activeTab.value].title,
    product_name: props.productName,
    product_category: props.category,
    product_flag1: props.tags.some((tag) => tag.type === 'popular'),
    product_flag2: props.tags.some((tag) => tag.type === 'new'),
    measurement_system: productsStore.system || null,
  };
  gaPush(gaPayload);
}
</script>

<template>
  <div class="c-product-card__tabs">
    <ul role="tablist" class="c-product-card__tablist">
      <li
        v-for="(tab, i) in tabs"
        :key="`${tab.id}-tablist`"
        role="presentation"
        class="c-product-card__tablist-item"
      >
        <button
          :id="tab.id"
          type="button"
          role="tab"
          :aria-selected="isSelected(i)"
          :tabindex="setTabindex(i)"
          class="c-product-card__tab-button"
          :class="{ 'is-active': isSelected(i) }"
          @click="handleTabBtnClick(i)"
          @keydown.left="handleKeydown(i, -1)"
          @keydown.right="handleKeydown(i, 1)"
          @keydown.down="handleKeydown(i, 'down')"
          ref="allTabsArr"
        >
          {{ tab.title }}
        </button>
      </li>
    </ul>

    <div
      v-for="(tab, i) in tabs"
      :key="`${tab.id}-tabpanel`"
      :id="`${tab.id}-tabpanel`"
      role="tabpanel"
      tabindex="-1"
      :aria-labelledby="tab.id"
      :hidden="!isSelected(i)"
      ref="allPanelsArr"
    >
      <ProductCardTabContent :tab="tab" :quoteLink="quoteLink" />
    </div>
  </div>
</template>